
import { useEffect, useRef, useState } from "react";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import CreateNewRequisition from "./CreateNewRequisition";
import { useDispatch, useSelector } from "react-redux";
import CostCenterDispatch from "Store/AssetManagement/CostCenter/CostCenterDispatch";
import AssetTypeDispatch from "Store/AssetManagement/AssetType/AssetTypeDispatch";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { operations } from "redux/Navigation";
import { useParams } from "react-router-dom";
import { APIToReact } from "Service/Transfer/ObjectStructure";
import {ApiToReact} from 'Service/AFEReClassification/ObjectStructure'
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import { getTransferOrderById } from "Store/Transfer/Transfer/TransferOrderByIdAction";
import { CONSTANTS } from "client/utils/constants";
import { resetOrderRequest } from "client/utils/AssetUtil";
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import { setCostCenters } from "Store/Organization/CostCenters/CostCentersAction";
import { IAssets } from "Model/IAssets";
import { GetVehicleTypeDropdown } from "redux/MyOrder/action";
import Moment from 'moment';
import { IAFERequest } from "Model/IAFEReClassification";
import { setAddressDetails } from "Store/Organization/AutoCompleteAddressDetails/AddressDetailsAction";

const CreateNewRequisitionContainer = (props: any) => {

  const dispatch = useDispatch();
  const setTotalPenaltyFee = props?.setTotalPenaltyFee;
  const totalPenaltyFee = props?.totalPenaltyFee;
  const showCart = props?.showCart;
  const dispatchNav = operations.dispatchNav(dispatch);
  const dispatchBranchDropdown = CostCenterDispatch.dispatchGetCostCenter(dispatch);
  const dispatchRequisitionTypeDropdown = AssetTypeDispatch.dispatchGetNonRequisitionAssetType(dispatch);

  ///selectors
  const {
    requisitionTypeDropdown,
    branchTypeDropdown,
    BranchDetails,
    orderDetails,
    selectedBranch,
    transferOrderByIdData,
    selectedRequestType,
    isEditOrder,
    isLastRequestDeleted,
    getUserDetails,
    isCostCenterAvailableForSubmit,
    vehicleTypeDropdown,
    afeReclassificationData,
    afeOrderByIdData
  }: any = useSelector((state?: any) => ({
    requisitionTypeDropdown: state.AssetManagement.NonRequisitionAssetType,
    branchTypeDropdown: state.CostCenter.costCenterDropDown,
    BranchDetails: state.GetBranchDetails.BranchDetails,
    orderDetails: state.TransferReducer.orderDetails,
    selectedBranch: state.TransferReducer.selectedBranch,
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
    selectedRequestType: state.TransferReducer.selectedRequestType,
    isEditOrder: state.TransferReducer.isEditOrder,
    isLastRequestDeleted: state.TransferReducer.isLastRequestDeleted,
    getUserDetails: state.UserProfile.getUserDetails,
    isCostCenterAvailableForSubmit: state.TransferReducer.isCostCenterAvailableForSubmit,
    vehicleTypeDropdown: state.setVehicleTypeId.VehicleTypeDropdown,
    afeReclassificationData: state.TransferReducer.afeReClassificationData,
    afeOrderByIdData: state.TransferReducer.afeOrderByIdData
  }));

  const initialState: IAssets = {
    requestIndex: 0,
    requestType: '',
    assetIndex: 1,
    assetNumber: '',
    unitNumber: '',
    model:'',
    costCenterNo:'',
    manufacturerName: '',
    dateDisposed:'',
    modelYear: '',
    color: '',
    description: '',
    serialNumber: '',
    licensePlateNumber: '',
    monthlyAmount: '',
    monthRemaining: 0,
    equipmentClass: '',
    equipmentClassDesc: '',
    eqStatus: '',
    eqStatusDesc: '',
    netBookedValue: '',
    odometerHourMeter: '',
    estimatedDispositionPrice: 0,
    conditionRating: '',
    conditionComment: '',
    openCloseAccordian: false,
    assetError: '',
    odometerHourMeterError: '',
    overallConditionError: '',
    overallConditionCommentError: '',
    estimatedDispositionPriceError: '',
    toolTip: '',
    isExist: false,
    isValid: false,
    isAttachmentsRequired: false,
    attachments: [],
    reactivationColorError: '',
    currentLicensePlateNo: '',
    currentLicensePlateError: '',
    reactivationComments: '',
    reactivationCommentsError: '',
    attachmentsError: '',
    receivingCostCenter: null,
    receivingCostCenterError: ''
  }

  const [branchTypeDropdownList, setBranchTypeDropdownList] = useState([]);
  const [quantity, setQuantity] = useState(1)
  const [isRevertChanges, setIsRevertChanges] = useState(false)
  const [updateCartStateRef, setUpdateCartRef] = useState(false)
  const [assetDetailList, setAssetDetailList] = useState<any>([initialState]);
  const [showExemptionFields, setShoweExemptionFields] = useState<any>(false);
  const [afeTypeList, setAfeTypeList] = useState<any>([]);
  const [isAFEPreAuthorized, setIsAFEPreAuthorized] = useState<boolean>(false);

  const [popupContent, setPopupContent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    popupOutlinebtnOnclick: () => { },
    popupPrimarybtnOnclick: () => { },
    actionby: "",
    value: 0,
    comments: "",
    hideDialog: () => { }
  });

  useEffect(() => {
    if (afeOrderByIdData?.orderId && afeReclassificationData) {
      dispatch(TransferAction.setIsEditOrder(true));
      setRequestType({
        label: afeReclassificationData?.orderType,
        value: afeReclassificationData?.orderTypeId,
        text: afeReclassificationData?.orderTypeId
      })
      setSelectedAfeType({
        label: afeReclassificationData?.afeDetail?.afeTypeId,
        value: afeReclassificationData?.afeDetail?.afeType,
        text: afeReclassificationData?.afeDetail?.afeType
      })
      setIsAFEPreAuthorized(afeReclassificationData?.isApprovalOverride)
    }
  }, [afeOrderByIdData, afeReclassificationData])

  useEffect(() => {
    if (vehicleTypeDropdown?.length) {
      const vehicleTypeDropdownTemp = vehicleTypeDropdown?.map((item: any, _index: number) =>
        ({ ...item, value: item.value, label: item?.text })
      );
      setAfeTypeList(vehicleTypeDropdownTemp);
    }
  }, [vehicleTypeDropdown])

  useEffect(() => {
    if(getUserDetails?.emailId){
      dispatchBranchDropdown(getUserDetails?.emailId);
      dispatchRequisitionTypeDropdown();
    }  
  }, [getUserDetails?.emailId]);

  useEffect(() => {
    const branchTypeDropdownListTemp = branchTypeDropdown?.map((item: any, _index: number) =>
      ({ ...item, value: (item.branchName), label: ((item.costCenter ? (item.costCenter + " - ") : "") + item.branchName), text: item.branchNo })
    );
    setBranchTypeDropdownList(branchTypeDropdownListTemp);
  }, [branchTypeDropdown])

  ///Modified dropDown values as required
  const requisitionTypeDropdownList = requisitionTypeDropdown?.map((item: any, index: number) =>
    ({ text: item.orderRequestTypeId, label: item.orderRequestType, value: item.orderRequestType, key: (index == 0 ? null : index.toString()) })
  );

  const resetDefaultState = () => {
    resetOrderRequest(dispatch);
    props.setShowCart(false)
  }

  const [showTransferAssetDetail, setShowTransferAssetDetail] = useState(false)
  const [showDispositionInformation, setShowDispositionInformation] = useState(false)
  const [successInfoAlert, setSuccessInfoAlert] = useState(false);
  const [showAFEInfoMessage, setShowAFEInfoMessage] = useState(false);
  const dismissSuccessAlert = () => {
    setSuccessInfoAlert(false);
    setShowTransferAssetDetail(true)
  }

  const [expandedItems, setExpandedItems] = useState<any>([]);
  const [requestType, setRequestType] = useState<any>('');
  const [branchValue, setBranchValue] = useState<any>({});
  const [clickedAdd, setClickedAdd] = useState<boolean>(false);
  const [isPreAuthorized, setIsPreAuthorized] = useState<boolean>(false);
  const [selectedAfeType, setSelectedAfeType] = useState<any>('');
  const RequestTypeFieldRef = useRef<any>([]);

  //this id is orderId for draft mode
  let { id, orderflow, orderType } = useParams();
  
  useEffect(() => {
    if (clickedAdd) {
      let successInfoTimer = setTimeout(() => {
        dismissSuccessAlert()
      }, 15000)
      return () => {
        clearTimeout(successInfoTimer);
      }
    }
  }, [requestType, clickedAdd])

  useEffect(() => {
    if (isLastRequestDeleted) {
      onCancelClick(true);
    }
  }, [isLastRequestDeleted])

  useEffect(() => {
    if (id) {
      if (orderType === CONSTANTS.AFEREQUEST) {
        if(afeOrderByIdData?.orderId == id){
          ApiToReact({
            dispatch,
            afeOrderByIdData,
            UploadAttachmentsDispatch,
            Moment
          })
        }
        setClickedAdd(true);
      } else {
        setShowTransferAssetDetail(true);
        setQuantity(transferOrderByIdData.quantity)
        if (transferOrderByIdData?.orderId == id) {
          APIToReact({
            dispatch,
            transferOrderByIdData
          });
        }
      }
    }
  }, [transferOrderByIdData, afeOrderByIdData]);

  useEffect(() => {
    if (id && branchTypeDropdownList && selectedBranch) {
      if (branchTypeDropdownList?.filter((branchItem: any) => branchItem?.value === selectedBranch?.branchName).length > 0) {
        dispatch(TransferAction.setIsCostCenterAvailableForSubmit(true))
      } else {
        dispatch(TransferAction.setIsCostCenterAvailableForSubmit(false))
      }

      setBranchValue(selectedBranch);
      if(orderType !== CONSTANTS.AFEREQUEST){
      setRequestType(orderDetails?.requestType);
      }
      dispatch(RequisitionAction.setOrderId(Number(id)));
      const order = orderDetails ? {
        ...orderDetails,
        selectedBranch: selectedBranch
      } : {
        selectedBranch: selectedBranch
      }
      dispatch(TransferAction.setTransferOrderDetails(order))
      setClickedAdd(true)
    }
  }, [branchTypeDropdownList, id, selectedBranch]);

  useEffect(() => {
    if (!id) {    
      branchTypeDropdownList?.map((branchItem: any) => {
        if (branchItem?.value === BranchDetails.name && branchItem?.costCenter === BranchDetails.branchNumber) {
          dispatch(TransferAction.setIsCostCenterAvailableForSubmit(true))
          if (requestType !== "" && (branchValue?.label?.split("-")[1].trim() !== BranchDetails.name)) {
            clearOrderDetailsOnBranchChange(branchItem);
          } else {
            setBranchValue(branchItem);
            const order = orderDetails ? {
              ...orderDetails,
              selectedBranch: branchItem
            } : {
              selectedBranch: branchItem
            }
            dispatch(TransferAction.setTransferOrderDetails(order))
          }
        }
      })
    }
  }, [BranchDetails, branchTypeDropdownList, id])

  useEffect(() => {
    if (id != undefined) {
      if (orderType === CONSTANTS.AFEREQUEST) {
        dispatch(TransferAction.getAfeOrderById(id));
      } else {
        dispatch(TransferAction.setTransferOrderNumber(id));
        dispatch(TransferAction.setIsEditOrder(true));
        dispatch(getTransferOrderById(id));
        if (orderflow == "orderDetails") {
          dispatchNav('AssetOrderDetail')
        }
      }
    }
  }, [])

  const resetState = (isDelete?: any) => {
    setShowTransferAssetDetail(false);
    setShowDispositionInformation(false)
    setQuantity(1)
    setClickedAdd(false)
    setSuccessInfoAlert(true)
    if(!isDelete){
    setIsPreAuthorized(false)
    }
  }

  const onChangeRequestType = (e: any, selectedItem: any) => {
    if(selectedItem?.label == CONSTANTS.AFEREQUEST){
       dispatch(GetVehicleTypeDropdown(selectedItem?.text));
       setSelectedAfeType('');
    }
      setRequestType(selectedItem);
      if (selectedItem?.value == "Transfer" || selectedItem?.value == "Reactivation") {
          RequestTypeFieldRef?.current[2]?.focus();
      }
      if (selectedItem?.value == "Disposition") {
          RequestTypeFieldRef?.current[1]?.focus();
      }
      dispatch(TransferAction.setAllCartAsset([]))
    setRequestType(selectedItem);
    if (selectedItem.label === CONSTANTS.TRANSFER) {
      dispatch(setCostCenters([]))
      dispatch(RequisitionAction.setIsAddAssetclick(false))
      setSuccessInfoAlert(true)
    }
    dispatch(TransferAction.setSelectedRequestType(selectedItem));
    const order = orderDetails ? {
      ...orderDetails,
      requestType: selectedItem,
      isApprovalOverride: false
    } : {
      requestType: selectedItem,
      isApprovalOverride: false
    }
    resetState(false);
    resetDefaultState();
    dispatch(TransferAction.setTransferOrderDetails(order))
  }

  const onChangeBranch = (e: any, selectedItem: any) => {
    if (branchValue?.label !== selectedItem.label) {
      if (clickedAdd && requestType?.label) {
        clearOrderDetailsOnBranchChange(selectedItem);
      } else {
        if (branchValue?.label?.length > 0) {
          setBranchValue(selectedItem);
          const order = { ...orderDetails, selectedBranch: selectedItem, isApprovalOverride: false }
          dispatch(TransferAction.setTransferOrderDetails(order))
          dispatch(TransferAction.setSelectedBranch(selectedItem));
        } else {
          setBranchValue(selectedItem);
          dispatch(TransferAction.setSelectedBranch(selectedItem));
          const order = JSON.parse(JSON.stringify(orderDetails))
          order.selectedBranch = selectedItem
          order.isApprovalOverride = false
          dispatch(TransferAction.setTransferOrderDetails(order))
          resetState(false);
          resetDefaultState();
        }
      }
    }
  }
  const clearOrderDetailsOnBranchChange = (selectedItem: any) => {

    setPopupContent({
      ...popupContent,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: <><p>Are you sure to change Branch?</p><p>Already entered details will be removed.</p></>,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      hideDialog: hideDialog,
      popupPrimarybtnOnclick: () => {
        resetState(false);
        resetDefaultState();
        hideDialog();
        setBranchValue(selectedItem);
        const order = { ...orderDetails, selectedBranch: selectedItem, isApprovalOverride: false }
        dispatch(TransferAction.setTransferOrderDetails(order))
        dispatch(TransferAction.setSelectedBranch(selectedItem));
        setRequestType("");
      },
      popupOutlinebtnOnclick: () => {
        hideDialog();
      }
    });

  }
  

  const hideDialog = () => setPopupContent({ ...popupContent, isDialogVisible: false })

  const onChangeQuantity = (e: any) => {
    if (e.target.value == '' || parseInt(e.target.value) == 0) {
      setQuantity(1);
    }
    else {
      setQuantity(parseInt(e.target.value));
    }
    RequestTypeFieldRef?.current[2]?.focus();
  }
  const incrementQuantity = () => {  
    setQuantity(quantity + 1)
    RequestTypeFieldRef?.current[2]?.focus();
  }
  const decrementQuantity = () => {
    if (quantity !== 0) {
      setQuantity(quantity - 1)
      RequestTypeFieldRef?.current[2]?.focus();
    }
  }

  const onClickAdd = () => {
    if (clickedAdd) {
      setPopupContent({
        ...popupContent,
        titleImg: ConfirmationBee,
        title: "ALREADY EXISTS",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: 'To increase the Quantity of Assets, click + on the Asset Information section.',
        primaryBtnText: "",
        outlineBtnText: "Ok",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: hideDialog,
        popupPrimarybtnOnclick: hideDialog
      })
    } else {
      setClickedAdd(true);
      if (requestType?.label !== CONSTANTS.AFEREQUEST) {
        dispatch(TransferAction.setIsLastRequestDeleted(false))
      } else {
        const headerTemp: IAFERequest = {
          orderId: 0,
          orderType: requestType?.label,
          orderTypeId: requestType?.text,
          branchId: branchValue?.text,
          costCenterNo: branchValue?.costCenter,
          costCenterName: branchValue?.label,
          userEmailId: getUserDetails?.emailId,
          savedBy: getUserDetails?.emailId,
          orderAction: "",
          attachments: [],
          isApprovalOverride: isAFEPreAuthorized,
          afeDetail: {
            branchValue: branchValue?.value,
            afeType: selectedAfeType?.value,
            afeDetailId: 0,
            itemNumber: 0,
            afeTypeId: selectedAfeType?.text,
            quantity: 0,
            attachments: [],
          }
        }
        dispatch(TransferAction.setAfeAssetDetailData({}))
        dispatch(TransferAction.setAfeBranchAddressDetail({}))
        dispatch(TransferAction.setAfeReClassificationData(headerTemp))

        if (selectedAfeType.label === CONSTANTS.LEASEHOLD_IMPROVEMENTS) {
          setShowAFEInfoMessage(true)
            setPopupContent({
              ...popupContent,
              titleImg: ConfirmationBee,
              title: "INFORMATION",
              isDialogVisible: true,
              subtextcontent: <><p>Please make sure the Real Estate team contacts landlord to make sure leasehold repairs/improvements are approved PRIOR to submitting.</p></>,
              outlineBtnText: "Ok",
              isSingleConfirmationBtn: true,
              hideDialog: () => {
                 hideDialog();
                 setSelectedAfeType('');
              },
              popupOutlinebtnOnclick: () => {
                setShowAFEInfoMessage(false)
                hideDialog();
              }
            })
        }
      }
    }
  }

  const onCancelClick = (isDelete?: any) => {
    resetDefaultState();
    resetState(isDelete);
  }

  const revertChangesOnClick = () => {
    setIsRevertChanges(true);
    APIToReact({
      dispatch,
      transferOrderByIdData
    })
  }

  useEffect(() => {
    RequestTypeFieldRef?.current[0]?.focus();
  }, [])

  useEffect(()=>{
    setIsPreAuthorized(orderDetails?.isApprovalOverride)
  }, [orderDetails?.isApprovalOverride])

  const handlePreAuthorizedFlagChange = (e: any, value:any) => {
    if (requestType?.label === CONSTANTS.AFEREQUEST) {
      setIsAFEPreAuthorized(value);    
      const order = afeReclassificationData ? {
        ...afeReclassificationData,
        isApprovalOverride: value
      } : {
        isApprovalOverride: value
      }
      dispatch(TransferAction.setAfeReClassificationData(order));
    } else {
      setIsPreAuthorized(value);
      const order = orderDetails ? {
        ...orderDetails,
        isApprovalOverride: value
      } : {
        isApprovalOverride: value
      }
      dispatch(TransferAction.setTransferOrderDetails(order));
    }
  }

  const handleChangeAFEType = (e?: any, item?: any) => {
    if (item) {
      setSelectedAfeType(item);
      if(item.label == CONSTANTS.BUILDING_IMPROVEMENTS){
         setShowAFEInfoMessage(true)
            setPopupContent({
              ...popupContent,
              titleImg: ConfirmationBee,
              title: "INFORMATION",
              isDialogVisible: true,
              subtextcontent: <><p>To find the correct branch for your order, please use the Leasehold ID Lookup.</p></>,
              outlineBtnText: "Ok",
              isSingleConfirmationBtn: true,
              hideDialog: () => {
                 hideDialog();
                 setSelectedAfeType('');
              },
              popupOutlinebtnOnclick: () => {
                setShowAFEInfoMessage(false)
                hideDialog();
              }
            })
      }
    }
    dispatch(setAddressDetails({}))
    const currentPreAuthorizedState = isPreAuthorized;
    const currentAFEPreAuthorizedState = isAFEPreAuthorized;
    resetState(false);
    setIsPreAuthorized(currentPreAuthorizedState);
    setIsAFEPreAuthorized(currentAFEPreAuthorizedState);
    resetDefaultState();
  }

  return (
    <CreateNewRequisition
      requisitionTypeDropdownList={requisitionTypeDropdownList}
      requestType={requestType}
      onChangeRequestType={onChangeRequestType}
      onChangeBranch={onChangeBranch}
      branchValue={branchValue}
      branchTypeDropdownList={branchTypeDropdownList}
      popupContent={popupContent}
      setExpandedItems={setExpandedItems}
      successInfoAlert={successInfoAlert}
      dismissSuccessAlert={dismissSuccessAlert}
      setSuccessInfoAlert={setSuccessInfoAlert}
      showTransferAssetDetail={showTransferAssetDetail}
      setShowTransferAssetDetail={setShowTransferAssetDetail}
      setShowMyCartTransfer={props.setShowMyCartTransfer}
      setShowCart={props.setShowCart}
      setShowCartClicked={props.setShowCartClicked}
      mobile={props.mobile}
      setShowCreateRequisition={props.setShowCreateRequisition}
      setSuccessAlert={props.setSuccessAlert}
      setErrorAlert={props.setErrorAlert}
      showDispositionInformation={showDispositionInformation}
      setShowDispositionInformation={setShowDispositionInformation}
      onChangeQuantity={onChangeQuantity}
      incrementQuantity={incrementQuantity}
      decrementQuantity={decrementQuantity}
      quantity={quantity}
      onClickAdd={onClickAdd}
      clickedAdd={clickedAdd}
      onCancelClick={onCancelClick}
      isEditOrder={isEditOrder}
      revertChangesOnClick={revertChangesOnClick}
      isRevertChanges={isRevertChanges}
      setIsRevertChanges={setIsRevertChanges}
      RequestTypeFieldRef={RequestTypeFieldRef}
      updateCartStateRef={updateCartStateRef}
      setUpdateCartRef={setUpdateCartRef}
      isPreAuthorized={isPreAuthorized}
      handlePreAuthorizedFlagChange={handlePreAuthorizedFlagChange}
      initialState = {initialState}
      setAssetDetailList = {setAssetDetailList}
      assetDetailList = {assetDetailList}
      setTotalPenaltyFee = {setTotalPenaltyFee}
      totalPenaltyFee = {totalPenaltyFee}
      setShoweExemptionFields = {setShoweExemptionFields}
      showExemptionFields = {showExemptionFields}
      transferOrderByIdData = {orderType == CONSTANTS.AFEREQUEST ? afeOrderByIdData : transferOrderByIdData}
      isCostCenterAvailableForSubmit = {isCostCenterAvailableForSubmit}
      showCart = {showCart}
      vehicleTypeDropdown = {vehicleTypeDropdown}
      afeTypeList = {afeTypeList}
      handleChangeAFEType = {handleChangeAFEType}
      selectedAfeType = {selectedAfeType}
      setClickedAdd = {setClickedAdd}
      showAFEInfoMessage = {showAFEInfoMessage}
      setShowAFEInfoMessage = {setShowAFEInfoMessage}
      isAFEPreAuthorized={isAFEPreAuthorized}
    />
  )
};

export default CreateNewRequisitionContainer;
